import { Box, LinearProgress } from '@mui/material';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { PageContainer } from '../containers';
import { Button } from '@zaplify/ui';
import { paths } from '../../routes/paths';
import EnsureAuthenticated from '../ensureAuthenticated';

export const SimpleTemplate = (props) => {
    return (
        <EnsureAuthenticated>
            <Suspense fallback={<LinearProgress />}>
                <PageContainer>
                    <Box
                        sx={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            display: 'flex',
                            alignItems: 'center',
                            width: '100vw',
                            height: 58,
                            backgroundColor: 'white',
                            boxShadow: '0px 2px 6px rgba(112, 144, 176, 0.07)',
                            paddingLeft: '32px',
                        }}
                    >
                        <Button variant="secondary" link={paths.HOME}>
                            Go to home
                        </Button>
                    </Box>
                    <Box
                        sx={{
                            marginTop: '58px',
                        }}
                    >
                        <Outlet />
                    </Box>
                </PageContainer>
            </Suspense>
        </EnsureAuthenticated>
    );
};
